<template>
    <div class="container-wrapper">
        <!-- Dialogue pour éditer la note -->
        <v-dialog v-model="showNoteDialog" max-width="500px">
            <v-card class="pb-2" color="purple">
                <v-card-title>
                    <h2 style="color:white;">Note du model</h2>
                    <v-spacer></v-spacer>
                    <v-icon color="success" class="mr-2" @click="saveEditedNoteTemplate">save</v-icon>
                    <v-icon color="error" @click="showNoteDialog = false">cancel</v-icon>
                </v-card-title>
                <v-card-text>
                    <v-container ma-0 pa-0>
                        <pre>
                            <code
                                :style="{ color: textColor }"
                                class="code-editor"
                                contenteditable="true"
                                @input="updateNote"
                                v-html="currentNoteString"
                            ></code>
                        </pre>
                    </v-container>
                </v-card-text>
            </v-card>
        </v-dialog>

        <!-- Dialogue pour créer une template -->
        <v-dialog v-model="showCreateDialog" max-width="850px">
            <v-card class="pb-2" color="purple">
                <v-card-title>
                    <h2 style="color:white;">Créer un nouvel élément</h2>
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <!-- Stepper pour mode création -->
                        <v-stepper
                            v-model="currentStep"
                            dark
                            class="stepper-wrapper"
                        >
                            <!-- Étapes du stepper -->
                            <v-stepper-header>
                                <v-stepper-step :complete="currentStep > 1" step="1">Saisie du code</v-stepper-step>
                                <v-divider></v-divider>
                                <v-stepper-step :complete="currentStep > 2" step="2">Ajout des informations</v-stepper-step>
                                <v-divider></v-divider>
                                <v-stepper-step step="3">Aperçu et finalisation</v-stepper-step>
                            </v-stepper-header>

                            <!-- Contenu du stepper -->
                            <v-stepper-items>
                                <!-- Étape 1 -->
                                <v-stepper-content step="1">
                                    <h3 style="color:white">Étape 1 : Saisissez le code</h3>
                                    <pre
                                        style="overflow-y: auto; height: 380px;"
                                        contenteditable="true"
                                        class="code-editor"
                                        @input="onCodeInput"
                                        @paste="onPaste"
                                        ref="editableCodeContainer"
                                    >{{ editableCode }}</pre>
                                    <div style="width: 100%; text-align: center;">
                                        <v-btn color="primary" class="mt-4" @click="currentStep = 2">Suivant</v-btn>
                                        <v-btn color="error" class="mt-4" @click="showCreateDialog = false">cancel</v-btn>
                                    </div>
                                </v-stepper-content>
                                <!-- Étape 2 -->
                                <v-stepper-content step="2">
                                    <h3 style="color:white">Étape 2 : Ajoutez des informations</h3>
                                    <div style="overflow-y: auto; height: 380px;">
                                        <!-- Sélection de language (Scope) -->
                                        <v-select
                                            :items="languageOptions"
                                            item-text="label"
                                            item-value="name"
                                            label="Langage"
                                            v-model="selectedLanguage"
                                            @change="onLanguageChange"
                                            placeholder="Sélectionnez un langage"
                                        />

                                        <!-- Sélection de la version -->
                                        <v-select
                                            v-if="selectedLanguage"
                                            :items="filteredVersions"
                                            item-text="label"
                                            item-value="id"
                                            label="Version"
                                            v-model="selectedVersionId"
                                            placeholder="Sélectionnez une version"
                                        />

                                        <!-- Sélection de l'application -->
                                        <v-select
                                            label="Application"
                                            v-model="selectedAppId"
                                            :items="stagelineAppOptions"
                                            item-value="id"
                                            item-text="nom"
                                            placeholder="Choisissez une application ..."
                                            outlined
                                        ></v-select>

                                        <!-- Saisie du titre -->
                                        <v-text-field
                                            label="Titre"
                                            v-model="seletedName"
                                            outlined
                                        ></v-text-field>

                                        <!-- Saisie de la description -->
                                        <v-textarea
                                            label="Description"
                                            v-model="selectedDescription"
                                            outlined
                                        ></v-textarea>

                                        <!-- Saisie de la note -->
                                        <v-textarea
                                            label="Note"
                                            v-model="selectedNote"
                                            outlined
                                        ></v-textarea>
                                    </div>
                                    <div style="width: 100%; text-align: center;">
                                        <v-btn color="primary" class="mt-4" @click="currentStep = 3">Suivant</v-btn>
                                        <v-btn color="grey" class="mt-4" @click="currentStep = 1">Retour</v-btn>
                                        <v-btn color="error" class="mt-4" @click="showCreateDialog = false">cancel</v-btn>
                                    </div>
                                </v-stepper-content>
                                <!-- Étape 3 -->
                                <v-stepper-content style="color:white;" step="3">
                                    <h3 >Étape 3 : Vérifiez vos données</h3>
                                    <div style="overflow-y: auto; height: 380px;">
                                        <div><strong>Nom : </strong><span class="stepper-txt-confirm">{{ seletedName }}</span></div>
                                        <div><strong>Description : </strong><span class="stepper-txt-confirm">{{ selectedDescription }}</span></div>
                                        <div><strong>Langage : </strong><span class="stepper-txt-confirm">{{ selectedLanguage }} (Version => {{ showVersionName() }})</span></div>
                                        <div><strong>Application : </strong><span class="stepper-txt-confirm">{{ showAppName() }}</span></div>
                                        <div><strong>Note : </strong><span class="stepper-txt-confirm">{{ selectedNote }}</span></div>
                                        <pre><strong>Code : </strong><br><span class="stepper-txt-confirm">{{ editableCode }}</span></pre>
                                    </div>
                                    <div style="width: 100%; text-align: center;">
                                        <v-btn color="green" class="mt-4" @click="saveNewTemplate">Créer</v-btn>
                                        <v-btn color="grey" class="mt-4" @click="currentStep = 2">Retour</v-btn>
                                        <v-btn color="error" class="mt-4" @click="showCreateDialog = false">cancel</v-btn>
                                    </div>
                                </v-stepper-content>
                            </v-stepper-items>
                        </v-stepper>
                    </v-container>
                </v-card-text>
            </v-card>
        </v-dialog>

        <div class="wrapper-box-left">
            <h2 class="title-section-wrapper">
                <span>Visionneur</span>
                <v-tooltip v-if="currentCodeShow" top>
                    <template v-slot:activator="{ on }">
                        <v-icon v-on="on" color="white" style="float:right;margin-left: 5px;" @click="openTemplateNote">speaker_notes</v-icon>
                    </template>
                    <span>Ouvrir la note du model</span>
                </v-tooltip>
                <v-tooltip v-if="currentCodeShow" top>
                    <template v-slot:activator="{ on }">
                        <v-icon  v-on="on" color="white" style="float:right;margin-left: 5px; margin-top: 2px; font-size: 20px;" @click="copyToClipboard">content_copy</v-icon>
                    </template>
                    <span>Presse-papier</span>
                </v-tooltip>
                <v-tooltip v-if="currentCodeShow && !isEditing" top>
                    <template v-slot:activator="{ on }">
                        <v-icon
                            v-on="on"
                            color="white"
                            style="float:right; margin-left: 5px;"
                            @click="isEditing = true"
                        >
                            edit
                        </v-icon>
                    </template>
                    <span>Modifier le code</span>
                </v-tooltip>
                <v-tooltip v-if="currentCodeShow && isEditing" top>
                    <template v-slot:activator="{ on }">
                        <v-icon
                            v-on="on"
                            color="white"
                            style="float:right; margin-left: 5px;"
                            @click="saveEditedTemplate()"
                        >
                            save
                        </v-icon>
                    </template>
                    <span >Sauvegarder le code</span>
                </v-tooltip>
                <v-tooltip v-if="currentCodeShow && isEditing" top>
                    <template v-slot:activator="{ on }">
                        <v-icon
                            v-on="on"
                            color="white"
                            style="float:right; margin-left: 5px;"
                            @click="isEditing = false"
                        >
                            undo
                        </v-icon>
                    </template>
                    <span >Annuler</span>
                </v-tooltip>
                <v-tooltip v-if="currentCodeShow && isEditing" top>
                    <template v-slot:activator="{ on }">
                        <v-icon
                            v-on="on"
                            color="white"
                            style="float:right; margin-left: 5px;"
                            @click="deleteTemplate"
                        >
                            delete
                        </v-icon>
                    </template>
                    <span >Supprimer le code</span>
                </v-tooltip>
                <v-tooltip top>
                    <template v-slot:activator="{ on }">
                        <v-icon
                            v-on="on"
                            color="white"
                            style="float:right;"
                            @click="openCreateDialog"
                        >
                            add
                        </v-icon>
                    </template>
                    <span>Créer un nouvel élément</span>
                </v-tooltip>
            </h2>

            <div v-if="currentCodeShow">
                <pre :class="[{ 'onEditMode': isEditing, 'onViewMode': !isEditing }]">
                    <code
                        class="code-wrapper language-js"
                        :contenteditable="isEditing"
                        ref="inlineEditor"
                        @input="updateCode"
                        @keydown="saveCaretPosition"
                        v-html="escapedCode"
                    ></code>
                </pre>
            </div>
            <div v-else class="icon-center">
                <v-icon color="white" x-large>image_not_supported</v-icon>
                <span class="overlay-text">Aucun model n'a encore été sélectionné!</span>
            </div>
        </div>
        <div class="wrapper-box-right">
            <h2 class="title-section-wrapper">
                <span>Model</span>
            </h2>

            <v-card style="background-color: #9a9a9a;" elevation="0">
                <v-card-title>
                    <v-text-field
                        v-model="search"
                        append-icon="search"
                        label="Rechercher"
                        single-line
                        hide-details
                        color="purple"
                    ></v-text-field>
                </v-card-title>
                <v-data-table
                    :headers="headers"
                    :items="templateCodeList"
                    :search="search"
                    hide-actions
                    style=""
                >
                    <template v-slot:headers="props">
                        <th v-for="(header, index) in props.headers" style="text-align: left; background-color: purple; color:white;border:1px solid purple;font-size: 15px;">
                            {{header.text}}
                        </th>
                    </template>
                    <template v-slot:items="props">
                        <tr class="model-row" :class="{ selected: currentItem === props.item }" style="cursor:pointer;" @click="showTemplate(props.item)">
                            <td>{{ props.item.name }}</td>
                            <td>{{ props.item.description }}</td>
                            <td>{{ props.item.codeType.name }}</td>
                            <td>{{ props.item.codeType.version }}</td>
                            <td>{{ props.item.codeType.scope }}</td>
                        </tr>
                    </template>
                    <template v-slot:no-results>
                        <v-alert :value="true" color="error" icon="warning">
                            Aucun résultat pour "{{ search }}"
                        </v-alert>
                    </template>
                </v-data-table>
            </v-card>
        </div>
    </div>
</template>

<script>
import $axios from "@/api";

export default {
    name: "DevTemplate",
    components: {
    },
    props: {
        saveCodeToDatabase: {
            type: Function,
            required: true
        },
        modifyCodeInDatabase: {
            type: Function,
            required: true
        },
        modifyNoteInDatabase: {
            type: Function,
            required: true
        },
        deleteTemplateInDatabase: {
            type: Function,
            required: true
        }
    },
    data: function() {
        return {
            loading: null,
            showNoteDialog:false,
            showCreateDialog: false,
            currentStep: 1,
            search: '',
            headers: [
                { text: 'Titre', value: 'name' },
                { text: 'Description', value: 'description' },
                { text: 'Type', value: 'type' },
                { text: 'Version', value: 'version' },
                { text: 'Porté', value: 'scope' },
            ],
            
            //Listes
            templateCodeList: [], //Liste des templates dans la BD
            codeTypeOptions: [], // Liste combinant type, version et scope
            stagelineAppOptions: [], // Liste des applications
            languageOptions: [],// Liste unique des langages disponibles
            filteredCodeTypes: [],// Options filtrées pour le 2e select

            //Nouveau template
            selectedLanguage: null,
            selectedVersion: null,
            selectedVersionId: null,
            selectedAppId: null,
            selectedTemplateId:null,
            seletedName: "",
            selectedDescription: "",
            selectedNote:"",

            //Template sélectionné
            editableNote: "",
            editableCode: "",
            currentItem: null,
            currentNoteString:"",
            currentCodeShow:null,

            caretPosition: null,
            isEditing: false,
            textColor: 'white'
        }
    },
    async mounted() {
        await this.loadAllTemplate();
        this.highlightCode(); // Coloration quand le composant est monté
    },
    computed: {
        // Code décodé et retransformé pour afficher les balises comme texte
        escapedCode() {
            const decoded = this.currentItem
                .replace(/&lt;/g, "<")
                .replace(/&gt;/g, ">")
                .replace(/&quot;/g, '"')
                .replace(/&nbsp;/g, " ")
                .replace(/&amp;/g, "&");

            // Encode les balises à nouveau pour empêcher leur interprétation
            return decoded
                .replace(/</g, "&lt;")
                .replace(/>/g, "&gt;");
        },
        filteredVersions() {
            // Trouver les versions correspondant au langage sélectionné
            const selected = this.codeTypeOptions.find(
                option => option.name === this.selectedLanguage
            );
            // Renvoie un tableau de versions sous forme d'objets contenant `id` et `label`
            return selected ? selected.versions : [];
        },
    },
    methods:{
        async loadAllTemplate(){
            try {
                const response = await $axios.get('/dev/index');
                this.formatCodeTypeOptions(response.data.typeCodeList);
                this.stagelineAppOptions = response.data.stagelineAppList;
                this.templateCodeList = response.data.devCodeTemplates;
            } catch (error) {
                console.error('Erreur lors du chargement des données :', error);
            }
        },
        async saveEditedTemplate() {
            try {
                this.isEditing = false;
                const response = await this.modifyCodeInDatabase({
                    id: this.selectedTemplateId,
                    code: this.editableCode
                });
                this.currentItem = response.data;
            } catch (error) {
                console.error("Erreur lors de la sauvegarde :", error);
            }
        },
        async saveEditedNoteTemplate() {
            this.showNoteDialog = false;
            try {
                const response = await this.modifyNoteInDatabase({
                    id: this.selectedTemplateId,
                    note: this.editableNote,
                });
                this.currentItem = response.data;
                this.$nextTick(() => {
                });
            } catch (error) {
                console.error("Erreur lors de la sauvegarde :", error);
            }
        },
        async saveNewTemplate() {
            try {
                const response = await this.saveCodeToDatabase({
                    name:this.seletedName,
                    description:this.selectedDescription,
                    note:this.selectedNote,
                    code: this.editableCode,
                    code_type_id: this.selectedVersionId,
                    code_model_id: 1,
                });
                this.currentItem = response.data;
                this.showCreateDialog = false;
            } catch (error) {
                console.error("Erreur lors de la sauvegarde :", error);
            }
        },
        async deleteTemplate(){
            try {
                await this.deleteTemplateInDatabase({
                    id: this.selectedTemplateId,
                });
                this.currentItem = null;
                this.isEditing = false;
                await this.loadAllTemplate();
            } catch (error) {
                console.error("Erreur lors de la suppression :", error);
            }
        },

        //Méthode utils
        formatCodeTypeOptions(typeCodeList) {
            this.languageOptions = typeCodeList.map((item) => ({
                name: item.name,
                label: item.label, // Utilise le label 'name + scope'
            }));

            this.codeTypeOptions = typeCodeList.map((item) => ({
                name: item.name,
                versions: item.versions.map((version) => ({
                    id: version.id, // Inclure l'ID de la version
                    label: version.version, // Utiliser 'version' comme texte pour le select
                })),
            }));
        },
        onLanguageChange() {
            // Réinitialiser la version sélectionnée lorsque le langage est changé
            this.selectedVersion = null;
        },
        onCodeInput(event) {
            const inputText = event.target.innerText;
            if (this.editableCode !== inputText) {
                this.editableCode = inputText; // Ne modifiez que si nécessaire
            }
        },
        onPaste(event) {
            event.preventDefault();
            this.editableCode = event.clipboardData.getData('text/plain');
        },
        openTemplateNote(){
            this.showNoteDialog = true;
        },
        showTemplate(item){
            this.selectedTemplateId = item.id;
            this.currentItem = item.code;
            this.currentNoteString = item.note;
            this.currentCodeShow = this.decodeHTMLCode(this.currentItem);
        },
        decodeHTMLCode(htmlCode) {
            // Remplace les entités HTML par les caractères réels
            return htmlCode
                .replace(/&lt;/g, "<")
                .replace(/&gt;/g, ">")
                .replace(/&quot;/g, '"')
                .replace(/&nbsp;/g, " ")
                .replace(/&amp;/g, "&");
        },
        copyToClipboard() {
            let htmlCode = this.decodeHTMLCode(this.currentItem);
            navigator.clipboard.writeText(htmlCode).then(() => {
                alert('Copying to clipboard was successful!');
            }, (err) => {
                alert('Could not copy text: '+ err);
            });
        },
        highlightCode() {
            this.$nextTick(() => {
                if (window.hljs) {
                    window.hljs.highlightAll();
                } else {
                    console.error("Highlight.js introuvable.");
                }
            });
        },
        openCreateDialog() {
            this.editableCode = '';
            this.seletedName = '';
            this.selectedDescription = '';
            this.currentStep = 1;
            this.showCreateDialog = true;
        },
        showAppName() {
            const appName = this.stagelineAppOptions.find(item => item.id === this.selectedAppId);
            return appName ? appName.app : "Application non trouvée"; // Si l'objet n'existe pas, renvoyer une valeur par défaut
        },
        showVersionName() {
            // Parcourt les langages pour trouver la version correspondant à `selectedVersionId`
            for (const option of this.codeTypeOptions) {
                const version = option.versions.find(v => v.id === this.selectedVersionId);
                if (version) {
                    return version.label; // Retourne le label de la version
                }
            }
            return "Version non trouvée"; // Retourne une valeur par défaut si aucune version n'est trouvée
        },
        saveCaretPosition(event) {
            // Sauvegarder la position du curseur
            const selection = window.getSelection();
            if (selection.rangeCount > 0) {
                this.caretPosition = selection.getRangeAt(0);
            }
        },
        restoreCaretPosition() {
            // Restaurer la position du curseur
            if (this.caretPosition) {
                const selection = window.getSelection();
                selection.removeAllRanges();
                selection.addRange(this.caretPosition);
            }
        },
        updateCode(event) {
            this.editableCode = event.target.innerText;
            this.$nextTick(() => {
                this.restoreCaretPosition();
            });
        },
        updateNote(event) {
            this.editableNote = event.target.innerText;
        },
    },
    watch: {
        currentItem() {
            this.highlightCode();
        },
    },
}
</script>

<style scoped>
.container-wrapper{
    display:inline-flex;
    width:100%;
    overflow-x:auto;
    overflow-y: hidden;
}
.wrapper-box-left{
    width:40%;
    height: 550px;
    margin:0 auto;
    border:2px outset silver;
    border-radius: 8px;
    background-color: #282c34;
    box-shadow: 1px 1px 5px rgba(1, 1, 1, 0.3);
}
.wrapper-box-right{
    width:59%;
    height: 550px;
    margin:0 auto;
    border:2px outset silver;
    border-radius: 8px;
    background-color:#9a9a9a;
    box-shadow: 1px 1px 5px rgba(1, 1, 1, 0.3);
}
.title-section-wrapper {
    background-color: purple;
    color: white;
    border-top: 1px solid transparent;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    padding: 0.5rem 1rem;
}
.icon-center {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
    margin-top: -40px; /* adjust this value as per your requirements */
}
.overlay-text {
    color: white;
}
.code-wrapper{
    height: 495px;
    font-size: 16px;
    overflow-y: auto;
    width: 98%;
    margin: 0 auto;
    margin-top: -20px;
    border-radius: 8px;
}
.onEditMode{
    height: 500px;
    width:100%;
    border:1px solid #b3e0fa;
    background-color: #ceebff;
    border-radius: 5px;
}
.onViewMode{
    height: 500px;
    width:100%;
    border:1px solid transparent;
    background-color: transparent;
    border-radius: 5px;
}
.model-row{
    background-color: #9a9a9a;
    border:1px solid #9a9a9a;
}
.model-row td{
    font-size: 14px;
    font-weight: bolder;
    font-family: "Source Code Pro", monospace;
    border-bottom: 1px solid purple;
}
.selected {
    background-color: white;
}
.code-editor {
    font-family: "Source Code Pro", monospace;
    background: #282c34;
    color: #ffffff;
    border: 1px solid #ddd;
    padding: 10px;
    border-radius: 5px;
    overflow: auto;
    height: 300px;
}
.stepper-wrapper{
    height: 590px;
}
.stepper-txt-confirm{
    color: chartreuse;
}
</style>
